/**
 * Cheap, dependency-free UA parser. Surfaces "Chrome on macOS", "Mobile
 * Safari on iOS", "Firefox on Linux" — enough for the sessions list. Returns
 * "" for empty / unrecognized UA strings so the caller can fall back.
 */
export function prettyUserAgent(ua: string | undefined | null): string {
  if (!ua) return "";
  const browser =
    /Edg\//.test(ua)
      ? "Edge"
      : /OPR\/|Opera/.test(ua)
        ? "Opera"
        : /Firefox\//.test(ua)
          ? "Firefox"
          : /Chrome\//.test(ua) && !/Edg\//.test(ua)
            ? "Chrome"
            : /Safari\//.test(ua) && !/Chrome\//.test(ua)
              ? /Mobile/.test(ua)
                ? "Mobile Safari"
                : "Safari"
              : null;
  const os =
    /Windows NT/.test(ua)
      ? "Windows"
      : /Mac OS X|Macintosh/.test(ua)
        ? "macOS"
        : /iPhone|iPad|iOS/.test(ua)
          ? "iOS"
          : /Android/.test(ua)
            ? "Android"
            : /Linux/.test(ua)
              ? "Linux"
              : null;
  if (browser && os) return `${browser} on ${os}`;
  if (browser) return browser;
  if (os) return os;
  return ua.slice(0, 40);
}
